import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

import { apiGet } from "./client";

/** GET /api/v2/usage/ai?month=YYYY-MM[&tenant_id=] — backend/app/core/api/usage.py. */

export const useCaseUsageSchema = z.object({
  calls: z.number(),
  tokens_in: z.number(),
  tokens_out: z.number(),
  cost_try: z.number(),
});
export type UseCaseUsage = z.infer<typeof useCaseUsageSchema>;

export const aiUsageResponseSchema = z.object({
  month: z.string(),
  calls: z.number(),
  tokens_in: z.number(),
  tokens_out: z.number(),
  cost_try: z.number(),
  by_use_case: z.record(z.string(), useCaseUsageSchema),
});
export type AiUsageResponse = z.infer<typeof aiUsageResponseSchema>;

export function fetchAiUsage(month: string, tenantId?: number): Promise<AiUsageResponse> {
  const qs = new URLSearchParams({ month });
  if (tenantId != null) qs.set("tenant_id", String(tenantId));
  return apiGet(`/api/v2/usage/ai?${qs.toString()}`, aiUsageResponseSchema);
}

export function useAiUsageQuery(month: string, tenantId?: number, enabled = true) {
  return useQuery({
    queryKey: ["usage", "ai", month, tenantId ?? "self"],
    queryFn: () => fetchAiUsage(month, tenantId),
    enabled: enabled && Boolean(month),
  });
}
